import { useWindowDimensions } from "react-native";
import { light_black } from "../../StyleHelpers";
import styled from "styled-components/native";
import ridevueLogo from "../../assets/Logo/logos.svg";
import Image from "../Image/Image";
import ImgProgressBar from "./ImgProgressBar";
import useGenericContentStore from "../../store/genericContent.store";
import NarrowScreenContainer from "../Layout/NarrowScreenContainer";

const StyledContainer = styled.View`
	background-color: ${light_black};
	height: 100%;
`;

const StyledMain = styled.View`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-left: 14.1%;
	margin-right: 14.1%;
	margin-bottom: 70px;
	border-radius: 16px;
	top: 15vh;
	overflow: hidden;
`;

const StyledButtonContainerWrapper = styled.View`
	display: flex;
	flex-direction: column;
	width: 71.8%;
	position: absolute;
	bottom: 17%;
	margin: 0 14.1% 0 14.1%;
	gap: 10px;
`;

const StyledButtonContainer = styled.View`
	display: flex;
	align-items: flex-start;
	gap: 1.5rem;
	align-self: stretch;
`;

const StyledButtonRow = styled.View`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 1.5rem;
	align-self: stretch;
`;

const StyledButton = styled.View<any>`
	width: 100%;
	flex: 1 0 0;
	border-radius: ${(props) => (props.isBorder ? "1rem" : 0)};
	height: ${(props) => props.height};
`;

/*Narrow*/
const StyledNarrowButtonContainer = styled.View`
	display: flex;
	width: 31.25rem;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
`;

const StyledNarrowLogo = styled.View`
	align-items: flex-end;
`;

const InitialLandingLoader = () => {
	const windowDimensions = useWindowDimensions();
	const isNarrow = useGenericContentStore((state: any) => state.isNarrow);

	const renderInitialLandingLoader = () => {
		return (
			<>
				{/* @ts-ignore */}
				<StyledMain>
					<Image
						source={{ uri: ridevueLogo }}
						windowDimensions={windowDimensions}
						width={windowDimensions.width * 0.7}
						height={windowDimensions.height * 0.25}
						style={{ marginTop: 41, marginBottom: "16.5625vw" }}
						resizeMode="contain"
					/>
				</StyledMain>
				{/* @ts-ignore */}
				<StyledButtonContainerWrapper>
					{/* @ts-ignore */}
					<StyledButtonContainer>
						{/* @ts-ignore */}
						<StyledButtonRow>
							{/* @ts-ignore */}
							<StyledButton height={"4.5rem"} isBorder>
								<ImgProgressBar isBorder />
							</StyledButton>
							{/* @ts-ignore */}
							<StyledButton height={"4.5rem"} isBorder>
								<ImgProgressBar isBorder />
							</StyledButton>
						</StyledButtonRow>
						{/* @ts-ignore */}
						<StyledButtonRow>
							<StyledButton height={"2.5rem"}>
								<ImgProgressBar isNoBorder />
							</StyledButton>
						</StyledButtonRow>
					</StyledButtonContainer>
				</StyledButtonContainerWrapper>
			</>
		);
	};

	const renderNarrowInitialLandingLoader = () => {
		return (
			<NarrowScreenContainer isLanding={true}>
				{/* @ts-ignore */}
				<StyledNarrowButtonContainer>
					{/* @ts-ignore */}
					<StyledButton>
						<ImgProgressBar isBorder />
					</StyledButton>
					{/* @ts-ignore */}
					<StyledButton>
						<ImgProgressBar isBorder />
					</StyledButton>
					<StyledButton>
						<ImgProgressBar isBorder />
					</StyledButton>
				</StyledNarrowButtonContainer>
				{/* @ts-ignore */}
				<StyledNarrowLogo>
					{/* @ts-ignore */}
					<Image source={{ uri: ridevueLogo }} windowDimensions={windowDimensions} width={"344px"} height={"200px"} resizeMode="contain" />
				</StyledNarrowLogo>
			</NarrowScreenContainer>
		);
	};

	return (
		// @ts-ignore
		<StyledContainer>{isNarrow ? renderNarrowInitialLandingLoader() : renderInitialLandingLoader()}</StyledContainer>
	);
};

export default InitialLandingLoader;
